import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { TESTIMONIALS, IMG } from "@/lib/content";

const GALLERY = [
  { img: IMG.krzAdvising, label: "Advising students · Warsaw" },
  { img: IMG.krzWithFlag, label: "With students at the consulate" },
  { img: IMG.krzWalking, label: "On campus · Warsaw" },
  { img: IMG.krzAirportTalk, label: "Welcoming new arrivals · Warsaw Chopin" },
  { img: IMG.krzAirportLuggage, label: "Arrival support · Chopin Airport" },
  { img: IMG.krzPortraitAirport, label: "Greeting students on arrival" },
];

export default function Proof() {
  return (
    <section className="section-pad bg-[#F3F1EA]" data-testid="home-proof">
      <div className="container-sp">
        <div className="max-w-3xl">
          <div className="overline">Proof & presence</div>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#0D1B2A] mt-3 leading-tight">
            Real students. Real universities. Real proximity to the system.
          </h2>
          <p className="text-[#4A5568] mt-5 max-w-xl">
            Years of on-the-ground work with institutions, professors and
            international students across Poland.
          </p>
        </div>

        {/* Gallery */}
        <div className="mt-14 grid grid-cols-2 md:grid-cols-3 gap-4">
          {GALLERY.map((g, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, scale: 0.98 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.5, delay: i * 0.04 }}
              className="relative rounded-2xl overflow-hidden group h-56 md:h-64"
              data-testid={`proof-image-${i}`}
            >
              <img
                src={g.img}
                alt={g.label}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0D1B2A]/80 via-transparent to-transparent" />
              <div className="absolute bottom-3 left-4 right-4 text-xs text-white/90 font-medium">
                {g.label}
              </div>
            </motion.div>
          ))}
        </div>

        {/* Testimonials */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.45, delay: i * 0.05 }}
              className="card-sp relative"
              data-testid={`testimonial-${i}`}
            >
              <Quote className="w-8 h-8 text-[#D7141A]/30 absolute top-6 right-6" />
              <p className="font-serif text-lg leading-relaxed text-[#0D1B2A] italic">
                "{t.quote}"
              </p>
              <div className="mt-5 pt-4 border-t border-[#EBE9E1]">
                <div className="text-sm font-medium text-[#0D1B2A]">{t.name}</div>
                <div className="text-xs text-[#718096] mt-0.5">{t.role}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
